var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex" } },
    [
      _c("auto-number-input", {
        staticStyle: { flex: "1" },
        attrs: {
          value: _vm.value,
          precision: 3,
          disabled: _vm.disabled,
          min: 0
        },
        on: { input: _vm.onInput, change: _vm.onChange }
      }),
      _c(
        "span",
        { staticStyle: { "min-width": "50px", "line-height": "28px" } },
        [_vm._v("CBM")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }